import { fetchPost } from '../Service/ApiService'

export const actionOfAddOnTask = (data,recordId,resolve, reject) => {
   

    try {
        fetchPost('addontaskdeduction/'+recordId, data, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};









